import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Select, Card, Typography, Row, Col, Form, Input, Radio } from 'antd';
import { BANK_LIST } from '../../config/constants/DropDownForms';
import rutValidator from '../../helpers/rutValidator';
import { SET_PREVIEW_DATA } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';

const { Title } = Typography;
const { Option } = Select;

const PaymentForm = ({ id, contractFormData, form, previewData, setPreview, regex }) => {
  const [paymentMethod, setPaymentMetod] = useState(contractFormData?.paymentType);

  useEffect(() => { setPaymentMetod(previewData?.paymentType); }, [previewData]);

  useEffect(() => {
    if (paymentMethod === 'transferencia') {
      let holdersData = {
        holdersName: `${contractFormData.lessor[0].firstName} ${contractFormData.lessor[0].lastName}`,
        holdersRut: contractFormData.lessor[0].rut,
        notificationEmail: contractFormData.lessor[0].email,
      };
      form?.setFieldsValue(holdersData);
      savePreview(holdersData);
    }
  }, [paymentMethod]);

  const savePreview = (data) => {
    setPreview({
      ...previewData,
      ...data
    });
  };

  return (
    <Card id={id}>
      <Row className="mb-2">
        <Col xs={24} className="d-flex mb-2 align-items-center">
          <Title level={3} className="text-purple mr-1 mb-2">Forma de pago del arriendo</Title>
        </Col>
        <Col xs={24}>
          <p className="mb-2">¿Cómo se realizará el pago del arriendo?</p>
          <Form.Item className="mb-2" name="paymentType" rules={[{ required: true, message: 'Debes seleccionar una opción' }]}>
            <Radio.Group
              onChange={(option) => {
                setPaymentMetod(option.target.value);
                previewData.paymentType = option.target.value;
                savePreview(previewData);
              }}
            >
              <Radio key={0} value='directo'>Directo al arrendador</Radio>
              <Radio key={1} value='transferencia'>Por transferencia bancaria</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {paymentMethod === 'transferencia' && (
        <React.Fragment>
          <Row>
            <Col xs={24} className="d-flex align-items-center">
              <Title level={5} className="mb-0 mr-1">Datos de cuenta para pago por transferencia</Title>
            </Col>
            <Col xs={24} className="d-flex mb-2 align-items-center">
              <p className="subtitle-text">Ingresa los datos de la cuenta donde deberá ser pagado mensualmente el monto del arriendo.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                name="typeBankAccount"
                label="Tipo de cuenta"
                rules={[{ required: true, message: 'Debes seleccionar una fecha' }]}
              >
                <Select size="large" style={{ width: '100%' }} placeholder="Seleccionar"
                  onChange={(option) => { savePreview({ typeBankAccount: option }); }}
                >
                  <Option key={0} value="Cuenta Corriente">Cuenta Corriente</Option>
                  <Option key={1} value="Cuenta Vista">Cuenta Vista</Option>
                  <Option key={2} value="Cuenta de Ahorro">Cuenta de Ahorro</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Número de cuenta bancaria"
                name="accountNumber"
                rules={[
                  ({
                    validator(_, value) {
                      if (value !== undefined && regex.test(value)) {
                        return Promise.reject(
                          'No debe usar simbolos especiales.',
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                  { required: true, message: 'Debes ingresar un número de cuenta' }
                ]}
              >
                <Input size="large"
                  onBlur={(event) => { savePreview({ accountNumber: event.target.value }); }}
                  maxLength={25}
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item name="bank" label="Banco del titular">
                <Select size="large" showSearch style={{ width: '100%' }} placeholder="Seleccionar"
                  onSelect={(value) => {
                    savePreview({ bank: value });
                  }}
                >
                  {BANK_LIST.map((bank, key) => (
                    <Option key={key} value={bank}>{bank}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Nombre del titular"
                name="holdersName"
                rules={[
                  ({
                    validator(_, value) {
                      if (value !== undefined && regex.test(value)) {
                        return Promise.reject(
                          'No debe usar simbolos especiales.',
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                  { required: true, message: 'Debes ingresar un nombre' }
                ]}
                size="large"
              >
                <Input
                  size="large"
                  onBlur={(event) => { savePreview({ holdersName: event.target.value }); }}
                  maxLength={100}
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Rut del titular"
                name="holdersRut"
                rules={[
                  ({
                    validator(_, value) {
                      if (value && rutValidator(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        'Debe ingresar un rut válido',
                      );
                    },
                  }),
                  { required: true, message: 'Debes ingresar un rut' },
                  {
                    pattern: new RegExp(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/),
                    message: 'Debe ingresar rut con guión'
                  },
                ]}
              >
                <Input
                  size="large"
                  onBlur={(event) => { savePreview({ holdersRut: event.target.value }); }}
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Correo de notificación"
                name="notificationEmail"
                rules={[{ required: true, pattern: new RegExp(/^\S+@\S+\.\S+$/), message: 'Debes ingresar un correo' }]}
              >
                <Input
                  size="large"
                  onBlur={(event) => { savePreview({ notificationEmail: event.target.value }); }}
                  maxLength={100}
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Card>
  );
};

PaymentForm.propTypes = {
  id: PropTypes.string.isRequired,
  contractFormData: PropTypes.object.isRequired,
  form: PropTypes.object,
  previewData: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
  regex: PropTypes.regex,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  previewData: state.contract.previewData,
  regex: state.forms.regex,
});

const actions = (dispatch) => ({
  setPreview: (data) => dispatch({ type: SET_PREVIEW_DATA, payload: { ...data } }),
});

export default connect(data, actions)(PaymentForm);